import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Canonical tokens + self-hosted fonts load before the app's own styles.
// Self-hosted, never Google Fonts — a project-wide rule (no third-party requests on any surface),
// and on this origin a font CDN would also be a request that leaks when staff are working.
import '@bymyword/tokens/tokens.css';
import '@bymyword/tokens/fonts.css';
import './index.css';
import { initSentry } from './lib/sentry';
import App from './App';

// No-op when VITE_SENTRY_DSN is absent; Replay/PII off; emails scrubbed from URLs (see sentry.ts).
initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
